import { render, staticRenderFns } from "./ImportarNeumaticosForm.vue?vue&type=template&id=3d9d0cb7"
import script from "./ImportarNeumaticosForm.vue?vue&type=script&lang=ts"
export * from "./ImportarNeumaticosForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports